// /admin/src/services/tutorService.js
import { adminAPI } from './api';

export const tutorService = {
  // 🎯 Get pending tutor applications - FIXED: Use getPendingTutors()
  getPendingApplications: async () => {
    try {
      console.log('📋 Fetching pending tutor applications...');
      const response = await adminAPI.getPendingTutors();
      
      console.log('📊 API Response:', response.data);
      console.log('📄 Applications data:', response.data.data);
      console.log('🔍 Applications count:', response.data.data?.length || 0);
      
      // Check if the response has the expected structure
      if (response.data.success && Array.isArray(response.data.data)) {
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.warn('⚠️ Unexpected response structure:', response.data);
        return {
          success: false,
          message: 'Unexpected response format',
          data: []
        };
      }
    } catch (error) {
      console.error('❌ Failed to fetch pending applications:', error);
      console.error('🔍 Error details:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load tutor applications',
        data: []
      };
    }
  },

  // 🎯 Approve tutor application - FIXED: Use approveTutor()
  approveApplication: async (tutorId) => {
    try {
      console.log('✅ Approving tutor application:', tutorId);
      
      const response = await adminAPI.approveTutor(tutorId);
      
      console.log('✅ Approval response:', response.data);
      
      return {
        success: true,
        data: response.data,
        message: 'Tutor application approved successfully'
      };
    } catch (error) {
      console.error('❌ Failed to approve application:', error);
      console.error('🔍 Error details:', error.response?.data);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to approve tutor application. Please try again.'
      };
    }
  },

  // 🎯 Reject tutor application - FIXED: Use rejectTutor()
  rejectApplication: async (tutorId, reason) => {
    try {
      console.log('❌ Rejecting tutor application:', tutorId);
      console.log('📝 Rejection reason:', reason);
      
      // Ensure reason is properly formatted
      let rejectionReason;
      
      if (typeof reason === 'string') {
        rejectionReason = reason;
      } else if (reason && typeof reason === 'object') {
        // Extract from object if needed
        rejectionReason = reason.reason || reason.message || JSON.stringify(reason);
      } else {
        rejectionReason = String(reason || 'Application rejected by admin');
      }

      // Trim and validate
      rejectionReason = rejectionReason.trim();
      
      if (!rejectionReason) {
        rejectionReason = 'Application rejected by admin';
      }

      console.log('📤 Sending rejection with reason:', rejectionReason);

      const response = await adminAPI.rejectTutor(tutorId, { 
        reason: rejectionReason 
      });
      
      console.log('✅ Rejection response:', response.data);
      
      return {
        success: true,
        data: response.data,
        message: 'Tutor application rejected successfully'
      };
    } catch (error) {
      console.error('❌ Failed to reject application:', error);
      console.error('🔍 Error details:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to reject tutor application. Please try again.'
      };
    }
  },

  // 🎯 Get all tutors (for management) - FIXED: Use getUsers() with role param
  getAllTutors: async (page = 1, limit = 20, filters = {}) => {
    try {
      console.log('📋 Fetching all tutors...', { page, limit, filters });
      
      const response = await adminAPI.getUsers('tutor', page, limit);
      
      console.log('📊 Tutors response:', response.data);
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data || [],
          pagination: response.data.pagination || {
            page,
            limit,
            total: 0,
            totalPages: 0
          }
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to load tutors',
          data: []
        };
      }
    } catch (error) {
      console.error('❌ Failed to fetch tutors:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load tutors',
        data: []
      };
    }
  },

  // 🎯 Get tutor details by ID - FIXED: Use getUserById()
  getTutorDetails: async (tutorId) => {
    try {
      console.log('📋 Fetching tutor details:', tutorId);
      
      const response = await adminAPI.getUserById(tutorId);
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to load tutor details'
        };
      }
    } catch (error) {
      console.error('❌ Failed to fetch tutor details:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load tutor details'
      };
    }
  },

  // 🎯 Ban tutor (user) - FIXED: Use banUser()
  banTutor: async (tutorId, reason) => {
    try {
      console.log('🚫 Banning tutor:', tutorId);
      console.log('📝 Ban reason:', reason);
      
      const response = await adminAPI.banUser(tutorId, reason);
      
      console.log('✅ Ban response:', response.data);
      
      return {
        success: true,
        data: response.data,
        message: 'Tutor banned successfully'
      };
    } catch (error) {
      console.error('❌ Failed to ban tutor:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to ban tutor'
      };
    }
  },

  // 🎯 Unban tutor (user) - FIXED: Use unbanUser()
  unbanTutor: async (tutorId) => {
    try {
      console.log('🔓 Unbanning tutor:', tutorId);
      
      const response = await adminAPI.unbanUser(tutorId);
      
      console.log('✅ Unban response:', response.data);
      
      return {
        success: true,
        data: response.data,
        message: 'Tutor unbanned successfully'
      };
    } catch (error) {
      console.error('❌ Failed to unban tutor:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to unban tutor'
      };
    }
  },

  // 🎯 Update tutor role - FIXED: Need to update this to match your API structure
  updateTutorRole: async (tutorId, role) => {
    try {
      console.log('🔄 Updating tutor role:', { tutorId, role });
      
      if (!['student', 'tutor', 'admin'].includes(role)) {
        return {
          success: false,
          message: 'Invalid role specified'
        };
      }
      
      // NOTE: This endpoint doesn't exist in your current adminAPI
      // You'll need to add it to api.js or create it here
      const response = await adminAPI.put(`/users/${tutorId}/role`, { role });
      
      console.log('✅ Role update response:', response.data);
      
      return {
        success: true,
        data: response.data,
        message: 'Tutor role updated successfully'
      };
    } catch (error) {
      console.error('❌ Failed to update tutor role:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update tutor role'
      };
    }
  },

  // 🎯 Delete tutor - FIXED: Need to check if this endpoint exists
  deleteTutor: async (tutorId) => {
    try {
      console.log('🗑️ Deleting tutor:', tutorId);
      
      if (!window.confirm('Are you sure you want to delete this tutor? This action cannot be undone.')) {
        return {
          success: false,
          message: 'Deletion cancelled'
        };
      }
      
      // NOTE: This endpoint doesn't exist in your current adminAPI
      // You'll need to add it to api.js or create it here
      const response = await adminAPI.delete(`/users/${tutorId}`);
      
      console.log('✅ Delete response:', response.data);
      
      return {
        success: true,
        data: response.data,
        message: 'Tutor deleted successfully'
      };
    } catch (error) {
      console.error('❌ Failed to delete tutor:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete tutor'
      };
    }
  },

  // 🎯 Get tutor statistics - FIXED: Use getDashboardStats()
  getTutorStatistics: async () => {
    try {
      console.log('📊 Fetching tutor statistics...');
      
      const response = await adminAPI.getDashboardStats();
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to load tutor statistics'
        };
      }
    } catch (error) {
      console.error('❌ Failed to fetch tutor statistics:', error);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load tutor statistics'
      };
    }
  }
};